import React, { useRef, useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { AiOutlineInfoCircle } from "react-icons/ai";

function useOutsideAlerter(ref, func) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        func();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, func]);
}

const PustsoPlusButton = ({ checked, onClick, idToScroll }) => {
  const putsoPlusRef = useRef(null);
  useOutsideAlerter(putsoPlusRef, () => setExpanded(false));
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      ref={putsoPlusRef}
      className="rounded-md border border-gray-300 px-8 py-6 cursor-pointer relative mb-6"
      style={{
        borderColor:
          checked.includes("Putso Plus") || expanded
            ? "#011E41"
            : "rgb(209,213,219)",
      }}
      onClick={() => {
        setExpanded((p) => !p);
        !checked.includes("Putso Plus") && onClick("Putso Plus - Nej");
        // onClick(null);
      }}
      aria-hidden="true"
    >
      <div
        className={
          "text-lg text-main-600 mb-1" +
          (checked.includes("Putso Plus") || expanded ? " font-semibold" : "")
        }
      >
        Putso Plus
      </div>
      <div className="text-sm text-gray-500" style={{ lineHeight: "24px" }}>
        utvändig fönsterputs var 3:e månad på bottenvåning (+invändigt som
        tillval)
      </div>
      {expanded && (
        <div
          className="mt-5"
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="text-main-600 font-medium mb-6">
            Vill du lägga till invändig fönsterputs en gång per år?
          </div>
          <div className="flex items-center">
            <div
              className="flex items-center justify-center mr-11"
              onClick={(e) => {
                e.stopPropagation();
                onClick("Putso Plus - Ja");
                document
                  .getElementById(idToScroll)
                  ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              aria-hidden="true"
            >
              <div
                className="rounded-full border flex items-center justify-center w-6 h-6 mr-3"
                style={{
                  borderColor:
                    checked === "Putso Plus - Ja"
                      ? "#011E41"
                      : "rgb(209,213,219)",
                }}
              >
                {checked === "Putso Plus - Ja" && (
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{ background: "#011E41" }}
                  ></div>
                )}
              </div>
              Ja
            </div>
            <div
              className="flex items-center justify-center"
              onClick={(e) => {
                e.stopPropagation();
                onClick("Putso Plus - Nej");
                isMobile &&
                  document
                    .getElementById(idToScroll)
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              aria-hidden="true"
            >
              <div
                className={
                  "rounded-full border w-6 h-6 mr-3 flex items-center justify-center"
                }
                style={{
                  borderColor:
                    checked === "Putso Plus - Nej"
                      ? "#011E41"
                      : "rgb(209,213,219)",
                }}
              >
                {checked === "Putso Plus - Nej" && (
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{ background: "#011E41" }}
                  ></div>
                )}
              </div>
              Nej
            </div>
          </div>
          {checked === "Putso Plus - Ja" && (
            <div className="flex text-gray-600 text-sm mt-6">
              <AiOutlineInfoCircle className="mr-2 mt-0.5" /> Vi kontaktar dig
              för att stämma av om antal och typ av fönster för prisuppgift
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PustsoPlusButton;
